import { render } from "./ExperiencePositionSoftware.vue?vue&type=template&id=12963211&scoped=true&bindings={}"
import script from "./ExperiencePositionSoftware.vue?vue&type=script&lang=ts"
export * from "./ExperiencePositionSoftware.vue?vue&type=script&lang=ts"

import "./ExperiencePositionSoftware.vue?vue&type=style&index=0&id=12963211&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-12963211"

export default script